export const MANUAL_ACTIONS = {
    SET_MESSAGE_STATUS: 'SET_MESSAGE_STATUS',
    SET_MESSAGE_CONV_ID: 'SET_MESSAGE_CONV_ID',
    MULTIMEDIA_MESSAGE_STATUS: "MULTIMEDIA_MESSAGE_STATUS"
}

export const setMessageStatus = (manualMessageStatus, phone, convId = 0) => ({
    type: MANUAL_ACTIONS.SET_MESSAGE_STATUS,
    manualMessageStatus,
    phone,
    convId
})

export const setMessageConvId = (convId) => ({
    type: MANUAL_ACTIONS.SET_MESSAGE_CONV_ID,
    convId
})


// WEBPACK FOOTER //
// ./src/redux/actions/A_manual_message.js